export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7878.2f4768f6.jpg";